(function () {
  const API_BASE_URL = window.appConfig?.apiBaseUrl || 'https://gate.jahikala.ee';
  const STORE_LOCATION_MATCHERS = ['TARTU', 'TALLINN'];
  const cache = new Map();

  const translations = {
    en: {
      fast: 'Fast',
    },
    et: {
      fast: 'Kiire',
    },
    ru: {
      fast: 'Быстро',
    },
  };

  const TRUCK_ICON = `
    <svg
      class="f-badge__icon"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M2.5 8.5H12.5V16H7.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.5 10.5H16.4L20 14V16H18.25" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16 11V14H19.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10.25 16H15.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.5 11H6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M0.75 14H5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <circle cx="6.5" cy="17" r="1.8" stroke="currentColor" stroke-width="1.8"/>
      <circle cx="17" cy="17" r="1.8" stroke="currentColor" stroke-width="1.8"/>
    </svg>
  `;

  function getTranslation(status) {
    const lang = (document.documentElement.lang || 'en').split('-')[0].toLowerCase();
    return (translations[lang] || translations.en)[status];
  }

  function normalizeId(value) {
    return String(value ?? '').split('/').pop();
  }

  function getItemVariantId(item) {
    return normalizeId(item?.shopifyVariantId ?? item?.variantId ?? item?.shopifyIdNumeric ?? item?.shopifyId);
  }

  function getStockLevel(item) {
    return typeof item?.stockLevel === 'number' && !Number.isNaN(item.stockLevel) ? item.stockLevel : 0;
  }

  function isStoreLocation(item) {
    const code = item?.location?.code ? item.location.code.toString().toUpperCase() : '';
    const name = item?.location
      ? (
          item.location.name ||
          item.location.title ||
          item.location.displayName ||
          item.location.locationName ||
          item.location.warehouseName ||
          ''
        )
          .toString()
          .toUpperCase()
      : '';

    return STORE_LOCATION_MATCHERS.some((matcher) => code.includes(matcher) || name.includes(matcher));
  }

  async function fetchInventory(productId) {
    if (!productId) return [];
    if (cache.has(productId)) return cache.get(productId);

    const request = fetch(`${API_BASE_URL}/stock/shopify/${productId}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => (Array.isArray(data?.responseObject) ? data.responseObject : []))
      .catch(() => []);

    cache.set(productId, request);
    return request;
  }

  function getDeliveryStatus(items, variantId, productId, singleVariant) {
    const normalizedVariantId = normalizeId(variantId);
    let scopedItems = normalizedVariantId
      ? items.filter((item) => getItemVariantId(item) === normalizedVariantId)
      : items;

    if (normalizedVariantId && !scopedItems.length && singleVariant) {
      scopedItems = items.filter((item) => getItemVariantId(item) === normalizeId(productId));
    }

    if (scopedItems.some((item) => isStoreLocation(item) && getStockLevel(item) > 0)) {
      return 'fast';
    }

    return '';
  }

  function isSoldOutElement(element) {
    const productColumn = element.closest('.product-column');

    if (
      productColumn &&
      (productColumn.dataset.productAvailable === 'false' || productColumn.classList.contains('product-column--sold-out'))
    ) {
      return true;
    }

    if (element.dataset.deliveryBadgeMode === 'product') {
      const productInfo = element.closest('[id^="ProductInfo-"]') || document;
      const variantInput = productInfo.querySelector('.product-variant-id');

      if (variantInput?.disabled) {
        return true;
      }
    }

    return false;
  }

  function getCurrentVariantId(element) {
    if (element.dataset.deliveryBadgeMode !== 'product') {
      return '';
    }

    const productInfo = element.closest('[id^="ProductInfo-"]') || document;
    const variantInput = productInfo.querySelector('.product-variant-id');
    return variantInput?.value || element.dataset.deliveryBadgeVariantId || '';
  }

  function renderBadge(element, status) {
    element.classList.remove('f-badge--delivery-fast', 'f-badge--delivery-delayed');

    if (!status) {
      element.textContent = '';
      element.classList.add('hidden');
      return;
    }

    element.innerHTML = `<span>${getTranslation(status)}</span>${TRUCK_ICON}`;
    element.classList.add(`f-badge--delivery-${status}`);
    element.classList.remove('hidden');
  }

  async function updateBadge(element) {
    if (isSoldOutElement(element)) {
      renderBadge(element, '');
      return;
    }

    const productId = element.dataset.deliveryBadgeProductId;
    const items = await fetchInventory(productId);
    if (isSoldOutElement(element)) {
      renderBadge(element, '');
      return;
    }
    const status = getDeliveryStatus(
      items,
      getCurrentVariantId(element),
      productId,
      element.dataset.deliveryBadgeSingleVariant === 'true'
    );
    renderBadge(element, status);
  }

  function updateAllBadges(root = document) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope.querySelectorAll('[data-delivery-badge-product-id]').forEach(updateBadge);
  }

  function bindVariantChanges() {
    document.addEventListener('variant:change', updateAllBadges);
    document.addEventListener('variantChange', updateAllBadges);
    document.addEventListener('variant:changed', updateAllBadges);
    document.addEventListener('change', (event) => {
      if (event.target.matches('.product-variant-id')) {
        updateAllBadges();
      }
    });
    document.addEventListener('delivery-badges:update', (event) => {
      updateAllBadges(event.detail?.root || document);
    });
  }

  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.DeliveryBadges = {
    updateAll: updateAllBadges,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateAllBadges();
      bindVariantChanges();
    });
  } else {
    updateAllBadges();
    bindVariantChanges();
  }
})();
